import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/services-usa/3d-game/workflow_bg.webp";

function Unitygamejourney() {
  return (
    <section
      className="unity_game_journey p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={7}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>
              Our Proven <span>3D</span> Game Development <span>Workflow</span>
            </h2>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-5">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="journey-box">
              <div className="journey-flex">
                <div className="num">01</div>
                <div className="journey-head">
                  <h5>Visionary Ideation</h5>
                </div>
              </div>
              <p>
                Our creative team polishes your game concept, thereby developing
                a strong base for production. We prepare detailed GDD, stunning
                concept art, clear and easy-to-follow wireframes, and UX flows
                with consideration of your project needs.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="journey-box">
              <div className="journey-flex">
                <div className="num">02</div>
                <div className="journey-head">
                  <h5>Rapid Prototyping</h5>
                </div>
              </div>
              <p>
                The creation of the initial game prototype occurs at breakneck
                speed and includes the simplest core loops, mechanics, and
                economy. This important step helps us establish a baseline for
                fine-tuning a design for the final game.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="journey-box">
              <div className="journey-flex">
                <div className="num">03</div>
                <div className="journey-head">
                  <h5>Immersive Design Phase</h5>
                </div>
              </div>
              <p>
                With the help of the prototype and GDD, we carefully develop
                game levels, polish mechanics, and narratives, and cut screens.
                This stage is typical for coordination between the creative and
                production departments of our company.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-xl-0 mb-4">
            <div className="journey-box">
              <div className="journey-flex">
                <div className="num">04</div>
                <div className="journey-head">
                  <h5>Rigorous Quality Assurance</h5>
                </div>
              </div>
              <p>
                Our QA specialists use the most appropriate testing software
                after development to guarantee that the game runs smoothly. This
                is why we repeat this sequence until all possible bugs that can
                hinder the users’ experience are addressed.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-md-0 mb-4">
            <div className="journey-box">
              <div className="journey-flex">
                <div className="num">05</div>
                <div className="journey-head">
                  <h5>Technical Realization</h5>
                </div>
              </div>
              <p>
                Our professional 3D game developers craft efficient and orderly
                code for gameplay constructing modules using recent game
                engines. We pay great attention to accessibility across
                different platforms, or in other words – availability for any
                user.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="journey-box">
              <div className="journey-flex">
                <div className="num">06</div>
                <div className="journey-head">
                  <h5>Continuous Improvement</h5>
                </div>
              </div>
              <p>
                After the launch of the app, it is essential to collect user
                responses and extensive analysis data. This feeds into our
                indefinite LiveOps support and helps in improving the engagement
                and retention rates that are important factors towards the
                success of your game in the current marketplace.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Unitygamejourney;
